// src/contexts/VerticalsContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { useApi } from "../hooks/useApi";
import { useAuth } from "./AuthContext";

// 1) Create context
const VerticalsContext = createContext();

// 2) Main hook to access everything
export const useVerticals = () => useContext(VerticalsContext);

// 3) Optional helper hook: only subVerticals
export const useSubVerticals = () => {
  const { subVerticals } = useContext(VerticalsContext);
  return subVerticals;
};

// 4) Optional helper hook: only verticals
export const useOnlyVerticals = () => {
  const { verticals } = useContext(VerticalsContext);
  return verticals;
};

// 5) Provider component
export const VerticalsProvider = ({ children }) => {
  const apiCall = useApi();
  const [verticals, setVerticals] = useState([]);
  const [subVerticals, setSubVerticals] = useState([]);
  const { isAuthenticated, authVersion } = useAuth();

  // fetch all verticals
  const fetchVerticals = async () => {
    try {
      const res = await apiCall("GET", "/Verticals"); // ✅ match backend casing
      setVerticals(res);
    } catch (err) {}
  };

  // fetch subverticals
  const fetchSubVerticals = async () => {
    try {
      const res = await apiCall("GET", "/SubVerticals"); // ✅ match backend casing
      setSubVerticals(res);
    } catch (err) {}
  };

  // Fetch when user is authenticated (and re-fetch after login)
  useEffect(() => {
    if (isAuthenticated) {
      fetchVerticals();
      fetchSubVerticals();
    }
  }, [isAuthenticated, authVersion]);

  return (
    <VerticalsContext.Provider value={{ verticals, subVerticals }}>
      {children}
    </VerticalsContext.Provider>
  );
};
